// extracted by mini-css-extract-plugin
export var attachment = "_qo-a";
export var emailContainer = "_qo-4";
export var emailContentPaddedContainer = "_qo-b";
export var emailHeader = "_qo-6";
export var emailIframe = "_qo-3";
export var emailInfoIcon = "_qo-9";
export var emailShortenedSummary = "_qo-e";
export var infoDropdown = "_qo-0";
export var infoRowBoundedContent = "_qo-d";
export var internal = "_qo-5";
export var merchant = "_qo-8";
export var messageInputContainer = "_qo-h";
export var normal = "_qo-7";
export var replyCard = "_qo-f";
export var subtleButton = "_qo-1";
export var subtleButtonIconContainer = "_qo-2";
export var toggleViewRepliesButton = "_qo-c";
export var wrappingText = "_qo-g";